export default __webpack_public_path__ + "static/media/sand-box.5ea93e99.svg";